import '@justgiving/loading/src/Loading.scss';
import './HomePage.scss';
import '@justgiving/totaliser/src/Totaliser.scss';

import * as Sentry from '@sentry/browser';

import React, { Suspense } from 'react';

import { ApolloProvider } from '@apollo/client';
import { I18nextProvider } from 'react-i18next';
import { client } from '../graphqlClient';
import config from '../config';
import i18n from '../i18next';
import { loadClient as loadChrome } from '@justgiving/chrome';
import { render } from 'react-dom';

export function initHomePage(Layout: JSX.Element) {
  Sentry.init({
    dsn: config.sentryDsn,
    release:
      document
        .querySelector('meta[data-application-version]')
        ?.getAttribute('data-application-version') ?? 'local',
    environment: config.env,
    whitelistUrls: [/justgiving\.com/, /jg-cdn\.com/],
    sampleRate: 0.1,
    ignoreErrors: [
      'Blocked a frame with origin "https://www.justgiving.com"',
      /^Non-Error promise rejection/,
    ],
  });

  loadChrome({
    headerVariant: 'consumer',
    footerVariant: 'full',
  });

  render(
    <Suspense fallback={<div />}>
      <I18nextProvider i18n={i18n}>
        <ApolloProvider client={client}>{Layout}</ApolloProvider>
      </I18nextProvider>
    </Suspense>,
    document.getElementById('app')
  );
}
